import * as Sentry from "@sentry/browser";
import { appConfig } from "@/app/app-config";
import { ignoreErrorStrings } from "@/debug/ignore-errors-string";

let analytics_bootstrapped = false;

export async function bootAnalytics(): Promise<void> {
  if (analytics_bootstrapped) return;
  analytics_bootstrapped = true;

  const isDev = import.meta.env.DEV;
  window.Sentry = Sentry;

  if (isDev) {
    console.log("[bootstrap/analytics] no-op: dev mode");
    return;
  }

  Sentry.init({
    dsn: appConfig.sentryDsn,
    ignoreErrors: ignoreErrorStrings,
    beforeBreadcrumb(breadcrumb: Sentry.Breadcrumb) {
      if (breadcrumb.category === "console") {
        return null;
      }
      return breadcrumb;
    },
  });

  console.log("[bootstrap/analytics] sentry initialized");
}
